module.exports = __webpack_public_path__ + "static/media/tree-svg.afff7f9b.svg";